import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c8ddd60"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["dsf_open", "dsf_title", "dsf_close_text"]
const _hoisted_2 = { style: {"max-width":"640px","max-height":"80vh"} }
const _hoisted_3 = { dsf_gap: "m" }
const _hoisted_4 = { dsf_gap: "s" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dsf-icon", {
  dsf_name: "MessageCircleReply",
  dsf_size: "1.8rem"
}, null, -1 /* HOISTED */))
const _hoisted_6 = { dsf_level: "s-semibold" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { dsf_level: "xs" }

import router from '@/router'
import { analytics } from '@/services/analyticsProvider'
import { ref, onMounted } from 'vue'
import outreachPreferencesGif from '@/assets/gifs/outreach-preferences.gif'

enum ANALYTIC_EVENTS {
  CLICK_OPEN = 'carrier-portal/click/announcements-open',
  CLICK_CLOSE = 'carrier-portal/click/announcements-close',
  CLICK_CTA = 'carrier-portal/click/announcement-cta',
}

const LS_NAME = 'orcas-annoucement-seen'
const LS_VALUE = '1' // Update this very time you add an announcement


export default /*#__PURE__*/_defineComponent({
  __name: 'Announcements',
  setup(__props) {

const renderModal = ref(false)
const isRead = ref(true)
const startTime = ref<number>()

onMounted(() => {
  const stored = window.localStorage.getItem(LS_NAME)

  if (stored && stored === LS_VALUE) {
    isRead.value = true
  } else {
    isRead.value = false
    onOpen(true) // Automatically open if hasn't been seen previously
  }
})

const onClose = (trackEvent = true) => {
  renderModal.value = false

  if (trackEvent) {
    analytics.trackEvent(ANALYTIC_EVENTS.CLICK_CLOSE, {
      readTime: getReadTime(),
    })
  }
}

const getReadTime = () =>
  startTime.value
    ? `${Math.round((performance.now() - startTime.value) / 1000 / 60)}m`
    : 'unknown'

const onOpen = (autoOpen = false) => {
  startTime.value = performance.now()
  analytics.trackEvent(ANALYTIC_EVENTS.CLICK_OPEN, {
    isRead: isRead.value,
    autoOpen,
  })

  renderModal.value = true
  isRead.value = true
  window.localStorage.setItem(LS_NAME, LS_VALUE)
}

const onCTAClick = () => {
  analytics.trackEvent(ANALYTIC_EVENTS.CLICK_CTA, {
    readTime: getReadTime(),
  })

  onClose(false)
  router.push({
    name: 'Profile',
    query: {
      page: 'outreach-preferences',
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dsf-icon", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onOpen())),
      class: _normalizeClass(['announcements', !isRead.value ? 'unseen' : undefined]),
      dsf_size: "18px",
      dsf_name: "Zap"
    }, null, 2 /* CLASS */),
    _createElementVNode("dsf-modal", {
      onClose: onClose,
      onOverlayClick: onClose,
      onEscape: onClose,
      dsf_open: renderModal.value,
      dsf_title: _ctx.$t('announcements.title'),
      dsf_close_text: _ctx.$t('announcements.close'),
      id: "announcements-modal"
    }, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("dsf-col", _hoisted_3, [
          _createElementVNode("dsf-row", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("dsf-text", _hoisted_6, _toDisplayString(_ctx.$t('announcements.campaigns.outreach-preferences.title')), 1 /* TEXT */)
          ]),
          _createElementVNode("img", {
            src: _unref(outreachPreferencesGif),
            alt: _ctx.$t('announcements.campaigns.outreach-preferences.title'),
            style: {"width":"100%","border-radius":"8px"}
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("dsf-text", _hoisted_8, _toDisplayString(_ctx.$t('announcements.campaigns.outreach-preferences.description')), 1 /* TEXT */),
          _createElementVNode("dsf-button", {
            dsf_size: "small",
            style: {"display":"inline"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onCTAClick()))
          }, _toDisplayString(_ctx.$t('announcements.campaigns.outreach-preferences.cta')), 1 /* TEXT */)
        ])
      ])
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})